// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Rsg9","rightAdornment":"Header_rightAdornment__1zb55"};